import { AuthenticationState } from '@b2x/common';

import { AUTH_PERSISTED_CONNECTION } from './constants';

export function getAuthenticationStorage(): AuthenticationState | null {
  return localStorage.getItem(AUTH_PERSISTED_CONNECTION)
    ? JSON.parse(localStorage.getItem(AUTH_PERSISTED_CONNECTION) as string)
    : null;
}
